import { FormEvent, useState } from 'react';
import { createGetLocale } from '@pwlaunch/pwa-sdk/config';
import { storePd, useAppContent, useInstallerContext } from '@pwlaunch/pwa-sdk';


const getLocale = createGetLocale<'playMarket'>();

const styles = {
	container: {
		width: '100%',
		height: '30px',
		backgroundColor: '#ddd',
		borderRadius: '5px',
		overflow: 'hidden',
		transform: 'rotate(-5deg)', // небольшой наклон влево
		boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)', // немного теней для объема
	},
	progress: {
		height: '100%',
		background: 'linear-gradient(to right, #4caf50, #2e7d32)', // градиент от зелёного к тёмно-зелёному
		borderRadius: '5px',
	},
};

function ContactsModal({ next }: { next: () => void }) {
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const { dataMap } = useAppContent<'playMarket'>();
	const locale = dataMap?.locale || {};

	const onSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		void storePd({ email, phone });
		const currentParams = new URLSearchParams(window.location.search);
		if (email) {
			currentParams.set('email', email);
		}

		if (phone) {
			currentParams.set('phone', phone);
		}

		const newQueryString = currentParams.toString();
		const newUrl = `${window.location.pathname}?${newQueryString}`;

		window.history.replaceState(null, '', newUrl);

		next();
	};

	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				bottom: 0,
				right: 0,
				left: 0,
				backgroundColor: 'rgba(0,0,0,0.75)',
				zIndex: 10000,
				display: 'inline-flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexGrow: 1,
			}}
		>
			<div
				style={{
					margin: 20,
					padding: 20,
					maxWidth: 600,
					maxHeight: '80dvh',
					// minHeight: '400px',
					position: 'relative',
					overflow: 'hidden',
					backgroundColor: 'white',
					display: 'flex',
					borderRadius: '10px',
					width: '100%',
					border: `1px solid #e1e3e1`,
				}}
			>
				<form action="/pwaTemplates/playMarket/public" onSubmit={onSubmit} style={{ flex: 1 }}>
					<div
						style={{
							width: '100%',
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<div
							style={{
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								width: '100%',
							}}
						>
							<div
								style={{
									fontWeight: 500,
									textTransform: 'uppercase',
									marginBottom: 50,
								}}
							>
								{typeof locale?.contactsModal?.title !== 'undefined' ? locale?.contactsModal?.title : ''}
							</div>
							{dataMap?.additionalData?.contactsModal?.askForEmail ?
								<>
									<div className="google_input">
										<label htmlFor="phone" className="label">
											{locale?.contactsModal?.emailLabel}
										</label>
										<input
											className="input"
											type="email"
											id="email"
											name="email"
											value={email}
											required
											onChange={e => setEmail(e.target.value)}
										/>
									</div>
								</>
							:	null}
							{dataMap?.additionalData?.contactsModal?.askForPhoneNumber ?
								<>
									<div className="google_input">
										<label htmlFor="phone" className="label">
											{locale?.contactsModal?.phoneLabel}
										</label>
										<input
											className="input"
											type="tel"
											id="phone"
											name="phone"
											required
											value={phone}
											onChange={e => setPhone(e.target.value)}
										/>
									</div>
								</>
							:	null}
						</div>
						<button className="header_btnIns_Btn__uB2nz" type="submit">
							<div className="header_btnIns_BtnProg__SMou9">
								<div className="header_btnIns_BtnProgLine__m+nW7" />
							</div>
							<div className="header_btnIns_BtnTitle__ctqbc">{locale.contactsModal?.continueButton || 'Continue'}</div>
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}

export function InstallButton({ buttonSpeed }: { buttonSpeed: number }) {
	const [contactsModalOpened, setContactsModalOpened] = useState(false);
	const { dataMap } = useAppContent<'playMarket'>();
	const needToOpenContactsModal =
		dataMap?.additionalData?.contactsModal?.askForEmail || dataMap?.additionalData?.contactsModal?.askForPhoneNumber;
	const props = useInstallerContext();
	const [progress, setProgress] = useState(0);
	const [lock, setLock] = useState(false);
	const updateSpeed = 10;

	function onClick(forceInstall?: boolean) {
		if (!forceInstall && needToOpenContactsModal) {
			setContactsModalOpened(true);
			return;
		}
		if (lock) return;
		props.installApp();
		setLock(true);
		const interval = setInterval(() => {
			setProgress(prev => {
				const val = Math.min(prev + (buttonSpeed || 1), 100);
				if (val < 100) return val;
				clearInterval(interval);
				setLock(false);
				setTimeout(() => setProgress(0), 1000);
				return 100;
			});
		}, updateSpeed);
	}

	let msg = getLocale('app:installButton');
	if (props.isInstalled) {
		msg = getLocale('app:isInstalled');
	} else {
		if (props.status === 'wait') {
			msg = 'Initializing';
		} else if (props.status === 'installing') {
			msg = getLocale('app:installProgress').replace('{{progress}}', `${props.progress}`);
		} else if (props.status === 'success') {
			msg = getLocale('app:isInstalled');
		}
	}

	return (
		<>
			{contactsModalOpened ?
				<ContactsModal
					next={() => {
						onClick(true);
						setContactsModalOpened(false);
					}}
				/>
			:	null}
			<button className="header_btnIns_Btn__uB2nz" onClick={() => onClick(props.isInstalled)}>
				<div
					style={{
						...styles.progress,
						width: `${progress}%`,
						transition: `width ${updateSpeed}ms linear`,
					}}
					className="header_btnIns_BtnProg__SMou9"
				>
					<div className="header_btnIns_BtnProgLine__m+nW7" />
				</div>
				<div className="header_btnIns_BtnTitle__ctqbc">{msg}</div>
			</button>
		</>
	);
}
